import { render, staticRenderFns } from "./NprTable.vue?vue&type=template&id=14765699"
import script from "./NprTable.vue?vue&type=script&lang=ts"
export * from "./NprTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports